// src/components/CountdownTimer.js
import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// --- ADDED: serverTimeOffset prop ---
export default function CountdownTimer({ endTime, variant = 'body1', sx = {}, serverTimeOffset = 0 }) {
  const [timeLeft, setTimeLeft] = useState(0); // Initialize to 0

  useEffect(() => {
    // Function to calculate remaining time using offset
    const calculateRemaining = () => {
        if (!endTime) return 0;
        // Use estimated server time for calculation
        const estimatedServerNow = Date.now() + serverTimeOffset;
        return Math.max(0, endTime - estimatedServerNow);
    };

    // Set initial time immediately using the offset
    setTimeLeft(calculateRemaining());

    // Only start interval if there's an end time and it's in the future (based on estimated server time)
    if (endTime && calculateRemaining() > 0) {
        const interval = setInterval(() => {
            const remaining = calculateRemaining();
            setTimeLeft(remaining);

            if (remaining === 0) {
                clearInterval(interval); // Stop interval when time is up
            }
        }, 500); // Update twice a second

        // Cleanup interval on unmount or when endTime/offset changes
        return () => clearInterval(interval);
    } else {
        // Ensure time is 0 if endTime is invalid or past
        setTimeLeft(0);
    }
    // --- ADDED: serverTimeOffset dependency ---
  }, [endTime, serverTimeOffset]);

  const totalSeconds = Math.floor(timeLeft / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  // Determine color based on time left
  const color = totalSeconds === 0 ? 'error.main'
              : totalSeconds < 10 ? 'warning.main'
              : 'text.primary';

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, ...sx }}>
      <Typography
        variant={variant}
        sx={{
          color: color,
          fontWeight: totalSeconds === 0 ? 'bold' : 'normal',
          fontVariantNumeric: 'tabular-nums',
          ...sx // Apply sx passed from parent
        }}
      >
        {`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`}
      </Typography>
    </Box>
  );
}
